import { supabase } from '@/config/supabase'

// Cache in-memory
let settingsCache: Record<string, string> = {}
let cacheLoaded = false

export async function fetchSetting(key: string): Promise<string | null> {
  if (cacheLoaded && key in settingsCache) {
    return settingsCache[key]
  }

  const { data, error } = await supabase
    .from('app_settings_cagliari')
    .select('value')
    .eq('key', key)
    .single()

  if (error || !data) {
    console.warn(`Setting "${key}" non trovato:`, error?.message)
    return null
  }

  settingsCache[key] = data.value
  cacheLoaded = true
  return data.value
}

export async function saveSetting(key: string, value: string): Promise<void> {
  const { error } = await supabase
    .from('app_settings_cagliari')
    .upsert({ key, value, updated_at: new Date().toISOString() }, { onConflict: 'key' })

  if (error) {
    console.error(`Errore salvataggio setting "${key}":`, error)
    throw error
  }

  settingsCache[key] = value
}

export function invalidateSettingsCache(): void {
  settingsCache = {}
  cacheLoaded = false
}
